import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FaqAccordion = ({ items }) => (
  <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
    {items.map((f, i) => (
      <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
        <AccordionTrigger
          data-testid={`faq-q-${i}`}
          className="py-5 text-left font-heading text-lg font-bold text-white transition-colors hover:text-gold hover:no-underline [&[data-state=open]]:text-gold"
        >
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="pb-5 text-base leading-relaxed text-steel">
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
